export default {
  list: [],
  current_office: {},
};
